module.exports = __webpack_public_path__ + "35381a45375047721dbaec4b68e49de3.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/mummy-body.png
// module id = 1879
// module chunks = 0